// @flow
import * as React from 'react';
import styled from 'styled-components';
import Input from 'components/Input';
import { colors } from '../theme';

const InputContainer = styled.div`
  display: inline-flex;
  width: 100%;
  position: relative;
  align-items: center;
`;

const PercentSign = styled.span`
  position: absolute;
  top: auto;
  bottom: auto;
  right: 18px;
  font-size: 18px;
  letter-spacing: 0px;
  color: ${colors.battleshipGrey};
`;

const PercentInput = (props: Object) => (
  <InputContainer>
    <Input {...props} height="100%" width="100%" pr="32px" />
    <PercentSign>%</PercentSign>
  </InputContainer>
);

export default PercentInput;
